import { useState, useEffect } from 'react'
import apiClient from '../../services/apiClient'
import Layout from '../../components/Layout'
import AdminTabs from '../../components/AdminTabs'
import CrudTable from '../../components/CrudTable'
import Spinner from '../../components/Spinner'

export default function AdminQuestions() {
  const [items, setItems]     = useState([])
  const [loading, setLoading] = useState(true)
  const load = () => {
    setLoading(true)
    apiClient.get('/admin/questions').then((r) => setItems(r.data.items)).finally(() => setLoading(false))
  }
  useEffect(() => { load() }, [])

  return (
    <Layout>
      <div className="page-header">
        <h1 className="page-title">Admin</h1>
      </div>
      <AdminTabs />
      <p style={{ fontSize: '0.875rem', color: 'var(--text-secondary)', marginBottom: '1rem' }}>
        The <code>question_key</code> is set automatically on creation and cannot be changed.
      </p>
      {loading ? (
        <div className="loading-state"><Spinner size="md" /> Loading…</div>
      ) : (
        <div className="card">
        <CrudTable
          items={items}
          columns={[
            { key: 'question_key',  label: 'Key' },
            { key: 'question_text', label: 'Question Text', editable: true },
            { key: 'display_order', label: 'Order', editable: true },
            { key: 'is_active',     label: 'Active', editable: true, type: 'boolean' },
          ]}
          newItemFields={[
            { key: 'question_text', label: 'Question Text' },
            { key: 'display_order', label: 'Order', type: 'number', default: 0 },
          ]}
          onCreate={async (data) => {
            await apiClient.post('/admin/questions', { ...data, display_order: Number(data.display_order) })
            load()
          }}
          onUpdate={async (id, data) => {
            await apiClient.put(`/admin/questions/${id}`, {
              question_text: data.question_text,
              display_order: Number(data.display_order),
              is_active: Number(data.is_active),
            })
            load()
          }}
          onDelete={async (id) => { await apiClient.delete(`/admin/questions/${id}`); load() }}
        />
        </div>
      )}
    </Layout>
  )
}

